module.exports = __webpack_public_path__ + "img/BJ.03d7f85a.svg";